import React from 'react';
import {Link, Typography} from '@mui/material';
import withMainContainer from '../../components/WithMainContainer.js';
import {withTitle} from '../../title.js';
import LegalContentWrapper from './LegalContentWrapper.js';
import LegalSection from './LegalSection.js';

const Terms = ()=><LegalContentWrapper title="תנאי שימוש" lastUpdated="08.08.2026">
  <LegalSection title="הקדמה">
    <Typography>
      ברוכים הבאים לאתר simonacherry.com, המופעל על-ידי סימונה צ'רי (להלן: "האתר").<br/>
      האתר כולל תכנים, בלוג, כתבות, שירותים מקוונים, ואפליקציות כגון אפליקציית מסרים אישיים ואזור אישי לתלמידים. בעתיד ייתכן שיוצעו גם קורסים מקוונים ומוצרים נוספים.
    </Typography>
    <Typography>
      השימוש באתר ו/או בתוכנו ו/או בשירותים המוצעים בו כפוף להסכמתך לתנאים המפורטים במסמך זה. אם אינך מסכים לתנאים - אינך רשאי לעשות שימוש באתר.<br/>
      עצם השימוש באתר מהווה את הסכמתך המלאה והבלתי חוזרת לכל תנאי המסמך, ומסיר כל טענה ו/או תביעה ו/או דרישה כלפי בעלת האתר, מפעיליו או מי מטעמם.
    </Typography>
  </LegalSection>
  <LegalSection title="1. תנאי סף ושינויים">
    <Typography>
      1.1 אין לעשות באתר כל שימוש שאינו מותר במפורש בתנאים אלה, לרבות שימוש מסחרי ללא אישור בכתב ומראש.
    </Typography>
    <Typography>
      1.2 אנו רשאים לשנות את תנאי השימוש בכל עת, ללא הודעה מוקדמת. השימוש באתר לאחר עדכון התנאים מהווה הסכמה לגרסה המעודכנת.
    </Typography>
    <Typography>
      1.3 אנו רשאים להפסיק את פעילות האתר, כולה או חלקה, בכל עת וללא הודעה מוקדמת.
    </Typography>
  </LegalSection>
  <LegalSection title="2. קישורים ותכני צד שלישי">
    <Typography>
      האתר עשוי לכלול קישורים לאתרים חיצוניים ותכנים של צדדים שלישיים. שימוש בתכנים אלו נעשה על אחריות המשתמש בלבד. בעלת האתר אינה אחראית לתוכן, לאמינותו, לאיכותו או לעדכניותו של כל מידע חיצוני.
    </Typography>
  </LegalSection>
  <LegalSection title="3. קניין רוחני">
    <Typography>
      3.1 כל התכנים, העיצובים, האפליקציות, הממשקים, הטקסטים, הסרטונים, התמונות, קבצי המדיה והקוד באתר מוגנים בזכויות יוצרים וחלים עליהם דיני הקניין הרוחני בישראל ובעולם, למעט תכנים שבהם הזכויות שייכות לצדדים שלישיים (כגון תמונות מאגר חוקיות).
    </Typography>
    <Typography>
      3.2 אין להעתיק, לשכפל, לצלם, להקליט, לתרגם, להפיץ, לשחזר או לקלוט בכל אמצעי, כל חלק מהאתר, למטרות מסחריות, ללא אישור בכתב ומראש מבעלת האתר.
    </Typography>
  </LegalSection>
  <LegalSection title="4. הגבלת אחריות">
    <Typography>
      4.1 השימוש באתר הוא על אחריותך הבלעדית והמלאה.
    </Typography>
    <Typography>
      4.2 כל המידע באתר ניתן לצורך העשרה והכוונה כללית בלבד, ואינו מהווה תחליף לייעוץ מקצועי (רפואי, משפטי, פיננסי, פסיכולוגי וכיו"ב).
    </Typography>
    <Typography>
      4.3 בעלת האתר ומי מטעמה אינם אחראים לנכונות, לעדכניות, להתאמה, לטעויות, להשמטות או להפסקות פעילות האתר, ולא יישאו בכל אחריות לנזקים ישירים או עקיפים שייגרמו כתוצאה מהשימוש בו.
    </Typography>
    <Typography>
      4.4 האתר עשוי להסתמך על שירותים חיצוניים (כגון ספקי אחסון או דיוור), ובעלת האתר אינה אחראית לכל תקלה או שינוי בשירותים אלו.
    </Typography>
  </LegalSection>
  <LegalSection title="5. פרטיות">
    <Typography>
      5.1 במסגרת השימוש באתר ייתכן שתתבקש למסור פרטים אישיים (שם, טלפון, מייל) וייאסף מידע טכני הקשור לשימושך (למשל Cookies לצורך התחברות לאזור התלמידים).
    </Typography>
    <Typography>
      5.2 השימוש במידע יתבצע בהתאם לחוק הגנת הפרטיות, התשמ"א-1981, ול<Link href="/privacy-policy">מדיניות הפרטיות</Link> המפורסמת באתר, ומהווה חלק בלתי נפרד מתנאי שימוש אלה.
    </Typography>
  </LegalSection>
  <LegalSection title="6. דיוור">
    <Typography>
      באמצעות מסירת פרטי התקשרותך והסכמה מפורשת לכך, הנך מאשר קבלת עדכונים, הצעות, ותוכן שיווקי בהתאם להוראות חוק התקשורת (בזק ושידורים), התשמ"ב-1982. ניתן להסיר את עצמך בכל עת באמצעות הקישור המיועד או פניה ישירה.
    </Typography>
  </LegalSection>
  <LegalSection title="7. שימוש אסור">
    <Typography>
      7.1 המשתמש מתחייב שלא לבצע באתר, בשירותים המוצעים בו או באפליקציות המקושרות אליו, כל פעולה שהיא בלתי חוקית לפי דיני מדינת ישראל או הפוגעת בזכויות צד שלישי.
    </Typography>
    <Typography>
      7.2 בין היתר, חל איסור על:<br/>
      <ul>
        <li>העלאה, שידור, הפצה או פרסום של תוכן פוגעני, משמיץ, מאיים, מטריד, גזעני או פורנוגרפי.</li>
        <li>שימוש בתכנים המוגנים בזכויות יוצרים או בזכויות קניין רוחני אחרות, ללא הרשאה מפורשת מבעל הזכויות.</li>
        <li>ביצוע פעולות שעלולות לשבש את פעילות האתר, לפגוע בשרתים או במערכות המחשב הקשורות אליו, או לנסות לעקוף אמצעי אבטחה.</li>
      </ul>
    </Typography>
  </LegalSection>
  <LegalSection title="8. שיפוי">
    <Typography>
      8.1 המשתמש מתחייב לשפות את בעלת האתר, עובדיה, מנהליה, שלוחיה, ספקיה וכל צד ג' הקשור להפעלת האתר, בעבור כל נזק, הפסד, הוצאה, תביעה או דרישה - לרבות הוצאות משפט, שכר טרחת עורכי דין ופיצויים - שייגרמו עקב:
    </Typography>
    <ul>
      <li>שימוש שלא בהתאם לתנאי השימוש</li>
      <li>הפרת זכויות יוצרים, סימן מסחר, או כל זכות קניין רוחני אחרת</li>
      <li>העלאה, פרסום, שידור או הפצה של תכנים בלתי חוקיים, פוגעניים או מפרים</li>
      <li>מסירת פרטים כוזבים או שגויים בעת השימוש באתר או האפליקציה</li>
      <li>כל פעולה המהווה הפרה של דין, הוראות או תקנות החלות בישראל.</li>
    </ul>
    <Typography>
      8.2 מובהר כי חובת השיפוי חלה גם על כל טענה שתועלה על ידי צד ג' כלשהו, כתוצאה ישירה או עקיפה משימושו של המשתמש בשירותים המוצעים באתר, בתכנים, במידע, באפליקציה או מהסתמכות עליהם.
    </Typography>
    <Typography>
      8.3 המשתמש מתחייב לבצע את השיפוי מיד עם קבלת דרישה ראשונה מבעלת האתר או ממי מטעמה, וזאת מבלי לגרוע מכל סעד או זכות אחרת העומדת לבעלת האתר לפי כל דין.
    </Typography>
  </LegalSection>
  <LegalSection title="9. הגבלת גיל">
    השימוש באתר ובשירותים המוצעים בו מיועד לאזרחים בגירים (בני 18 ומעלה).<br/>
    קטינים (מתחת לגיל 18) רשאים להשתמש באתר רק לאחר קבלת אישור מפורש מהורה או אפוטרופוס חוקי.<br/>
    עצם השימוש באתר על-ידי קטין מהווה הצהרה כי קיבל את האישור האמור, וכי בעלת האתר לא תישא באחריות לאי-קבלת אישור כאמור.<br/>
    השימוש באתר כפוף לדין הישראלי ולסמכות השיפוט של בתי המשפט בישראל.
  </LegalSection>
  <LegalSection title="10. הדין החל וסמכות השיפוט">
    הדין החל על תנאי שימוש אלה הוא הדין של מדינת ישראל, וסמכות השיפוט הבלעדית נתונה לבתי המשפט המוסמכים במחוז מרכז.
  </LegalSection>
  <LegalSection title="11. רכישות, סליקה ואמצעי תשלום">
    <Typography>
      11.1 באתר ייתכן ויוצעו מוצרים או שירותים בתשלום, לרבות מנוי לאפליקציית המסרים ולשירותים דיגיטליים נוספים. התשלום יתבצע באמצעות מערכת סליקה חיצונית ומאובטחת, התואמת את תקן PCI-DSS לשמירת פרטי אשראי.
    </Typography>
    <Typography>
      11.2 בעלת האתר אינה שומרת ואינה נחשפת לפרטי האשראי של הרוכשים, והם מנוהלים ומתוחזקים באופן בלעדי על-ידי חברת הסליקה. כל תקלה, עיכוב, או בעיית חיוב הקשורים לאמצעי התשלום יהיו באחריות ספק הסליקה.
    </Typography>
    <Typography>
      11.3 הרכישה באתר היא עבור שירותים דיגיטליים - גישה לאפליקציה, לתוכן, או למוצר מקוון - בהתאם לתיאור המופיע בעמוד המכירה. על המשתמש לקרוא בעיון את כל פרטי המוצר/השירות לפני הקנייה.
    </Typography>
    <Typography>
      11.4 הזמנה תיחשב כמושלמת אך ורק לאחר סיום תהליך החיוב והתקבלות אישור העסקה מצד חברת הסליקה. בעלת האתר שומרת לעצמה את הזכות לבטל כל עסקה שאינה עומדת בתנאים אלה או במקרה של חשד לביצוע פעולה שלא כדין.
    </Typography>
  </LegalSection>
  <LegalSection title="12. מדיניות ביטולים והחזרים">
    <Typography>
      12.1 מדיניות ביטול עסקה תיעשה בהתאם לחוק הגנת הצרכן, התשמ"א-1981, ובהתאם לאופי השירות הנרכש.
    </Typography>
    <Typography>
      12.2 עבור מוצרים דיגיטליים/אפליקציה/שירותים מקוונים - ברגע שהמשתמש קיבל גישה לשירות (כגון שליחת אימייל התחברות או פתיחת הרשאה באפליקציה), ייתכן ולא יתאפשר החזר, אלא אם צוין אחרת בעמוד המכירה.
    </Typography>
    <Typography>
      12.3 בקשות לביטול עסקה יישלחו בכתב בטופס המופיע בעמוד "צור קשר".
    </Typography>
    <Typography>
      12.4 בעלת האתר רשאית להפסיק את הגישה לשירות במקרה של הפרת תנאי השימוש או שימוש לרעה, ללא החזר כספי.
    </Typography>
  </LegalSection>
  <LegalSection title="13. אחריות הרוכש">
    <Typography>
      13.1 המשתמש מצהיר כי פרטי הרכישה שסיפק הם מדויקים וכי הוא בעל האמצעי הממומן.
    </Typography>
    <Typography>
      13.2 בעלת האתר לא תישא באחריות לנזקים שנגרמו עקב:<br/>
      <ul>
        <li>שימוש שגוי בשירות</li>
        <li>הזנת פרטים שגויים</li>
        <li>תקלות בתשתיות אינטרנט/מכשיר של המשתמש</li>
        <li>פעולות של חברת הסליקה</li>
      </ul>
    </Typography>
    <Typography>
      13.3 הנהלת האתר אינה נושאת בכל אחריות לנזק, הפסד, הוצאות או פגיעה שתיגרמנה עקב שימוש באתר, באפליקציות או בשירותים, לרבות כתוצאה מהסתמכות על מידע, תקלות טכניות, עיכובים, הפרעות או שינויים בשירות.
    </Typography>
  </LegalSection>
  <LegalSection title="14. מדיניות אספקת מוצרים">
    <Typography>
      14.1 באתר מסופקים שירותים ותכנים דיגיטליים בלבד, לרבות גישה לאפליקציית המסרים, קורסים ותכנים מקוונים, סדנאות אונליין ושירותי ייעוץ מרחוק.
    </Typography>
    <Typography>
      14.2 לאחר השלמת התשלום ואישור העסקה, הגישה לשירות הדיגיטלי תימסר למשתמש באופן מיידי באמצעות דוא״ל, קישור גישה או מסירת פרטים לאזור אישי - בהתאם לאופי השירות שנרכש.
    </Typography>
    <Typography>
      14.3 שירותים הכוללים תיאום פגישה אישית (בזום או באופן מקוון אחר) יסופקו לאחר תיאום מועד מול המשתמש עד 48 שעות מרגע אישור התשלום.
    </Typography>
    <Typography>
      14.4 במידה ותתרחש תקלה טכנית או עיכוב באספקת השירות הדיגיטלי, הנהלת האתר תפעל להשלים את האספקה במועד סביר ובהתאם לנסיבות.
    </Typography>
    <Typography>
      14.5 על המשתמש לוודא מסירת פרטים נכונים לצורך אספקת השירות (לרבות כתובת דוא״ל). הנהלת האתר אינה אחראית לעיכובים הנובעים ממסירת מידע שגוי או חסר.
    </Typography>
    <Typography>
      14.6 מובהר כי האתר מספק שירותים ותכנים דיגיטליים בלבד. לא מסופקים מוצרים פיזיים, ומשכך לא חלות הוראות אספקה החלות על מוצרים מוחשיים.
    </Typography>
  </LegalSection>
  <LegalSection title="15. אחריות מוצר">
    <Typography>
      15.1 השירותים הדיגיטליים באתר ניתנים "כמו שהם" (AS IS), בהתאם לתיאור המוצג בדף השירות בעת הרכישה.
    </Typography>
    <Typography>
      15.2 הנהלת האתר מתחייבת לספק למשתמש את הגישה לשירות או לתוכן הדיגיטלי כפי שתואר, ובכפוף לתנאי השימוש.
    </Typography>
    <Typography>
      15.3 מאחר שמדובר בשירותים חווייתיים/לימודיים/מקוונים, אין התחייבות לתוצאה אישית, להתאמה מדויקת לכל משתמש או להשגת יעד מסוים. האחריות מוגבלת לאספקת השירות בלבד.
    </Typography>
    <Typography>
      15.4 הנהלת האתר תספק תמיכה טכנית סבירה במקרה של תקלה בגישה לשירות הדיגיטלי או לאפליקציה.
    </Typography>
    <Typography>
      15.5 הנהלת האתר, עובדיה, מי מטעמם או ספקיה אינם אחראים לכל נזק ישיר, עקיף, תוצאתי, מיוחד או כספי שייגרם למשתמש בעקבות שימוש בשירותים, בתכנים, בהדרכות, באפליקציות או בהחלטות שנעשו כתוצאה מהסתמכות עליהם.
    </Typography>
    <Typography>
      15.6 השירותים באתר אינם מהווים ייעוץ רפואי, פסיכולוגי, משפטי, עסקי או פיננסי. כל הסתמכות על התוכן הינה על אחריותו הבלעדית של המשתמש, והנהלת האתר אינה אחראית לכל תוצאה הנובעת מהשימוש בשירותים.
    </Typography>
    <Typography>
      15.7 הנהלת האתר אינה אחראית לכל אובדן רווח, אובדן נתונים, הפסד כספי, עוגמת נפש או כל נזק אחר שייגרם למשתמש כתוצאה מגישה לשירותים, משימוש בהם, ממידע שגוי שהוזן או מתקלה טכנית.
    </Typography>
    <Typography>
      15.8 הנהלת האתר אינה מתחייבת לכך שהשירות הדיגיטלי או האפליקציות יהיו זמינים בכל זמן, ללא הפסקות, תקלות או שיבושים, ולא תישא בכל אחריות בגין שיבושים אלו.
    </Typography>
  </LegalSection>
</LegalContentWrapper>;

export default withMainContainer(withTitle('תנאי שימוש', Terms));
